import { TdDraggableProps } from './type';

const props: TdDraggableProps = {
  /** 移动方向 */
  direction: {
    type: String,
    value: 'all',
  },
};

export default props;
